<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay preguntas que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha agregado ninguna pregunta
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import { convertQuestionsTypeLabel } from '@/plugins/complianceScripts/index.js'

export default {
    name: 'SettingListQuestions',

    components: {
        AlertDismiss
    },

    async mounted(){
        await this.getAll();

        this.$eventBus.$on(EventNames.CreatedQuestion, async () => {
            this.cargandoTabla();
            await this.getAll();
            this.cargandoTabla();
        });
    },

    data() {
        return {
            isBusy: false,

            fields: [
                { key: 'description', label: 'Descripción de la pregunta' },
                { key: 'tipo', label: 'Tipo' },
                { key: 'required', label: 'Requerida' }
            ],

            selected: [],

            items: []
        }
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar data

            return filtered;
        }
    },

    methods:{
        ...mapActions(["getAllQuestions"]),

        onRowSelected(items) {
            this.selected = items;
        },

        cargandoTabla(){
            this.isBusy = ! this.isBusy;
        },

        async getAll(){
            this.cargandoTabla();
            let result = await this.getAllQuestions();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.cargandoTabla();
                return;
            }

            let data = result.data.map((q) => {
                return {
                    id: q.id,
                    description: q.description,
                    tipo: convertQuestionsTypeLabel(q.type),
                    required: this.convertRequired(q.required)
                }
            });

            this.items.push(...data);
            this.cargandoTabla();
        },

        convertRequired(value){
            return value == true ? 'Si' : 'No';
        }
    }
    
}
</script>
<style>
    
</style>
